import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useCurrentUser, useSessionManager } from '@syscolect/application'
import { NoOrganizationScreen } from './NoOrganizationScreen'

export interface ProtectedRouteProps {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()
  const { currentUserId, isLoading } = useCurrentUser()
  const { sessionStatus } = useSessionManager()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg text-sm text-fg-muted">
        Carregando…
      </div>
    )
  }

  if (!currentUserId) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (sessionStatus === 'resolving') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg text-sm text-fg-muted">
        Carregando…
      </div>
    )
  }

  if (sessionStatus === 'no-org') {
    return <NoOrganizationScreen />
  }

  return children
}
